import { InformationContainer } from '@features/common';
import useFirebase from '@hooks/firebase.hook';
import { ProcesoDivision } from '@interfaces/firestore-documents.interfaces';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Grid, IconButton, Theme, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import ProcessDropdown from './ProcessDropdown';
import ProcessItem from './ProcessItem';

interface Props {
	data: ProcesoDivision;
	isActive: boolean;
	onClick(): void;
	width: number | string;
}
const Process: React.FC<Props> = ({ data, isActive, onClick, width }) => {
	const { combos, serviceLevels } = useFirebase();
	const [isClientOpen, setIsClientOpen] = useState<boolean>(false);

	const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

	return (
		<InformationContainer
			canClick
			active={isActive}
			disabled={!data.estado}
			id={`process-${data.id_proceso}`}
			style={{
				paddingBottom: 10,
				paddingLeft: 25,
				paddingRight: 35,
				paddingTop: 16,
				width,
			}}
		>
			<div id="1" onClick={onClick} role="button" tabIndex={0}>
				<Typography color="#707070" fontFamily="Montserrat" fontSize={12} fontWeight={500}>
					ID: {data.id_proceso_text}
				</Typography>
				<Typography color="#003C82" fontFamily="Montserrat" fontSize={16} fontWeight={700}>
					{data.nombre_proceso}
				</Typography>
				{/* Rango de guías y consecutivo */}
				<>
					<Typography
						color="#686868"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={700}
						style={{ marginTop: 12 }}
					>
						Rango de guías y Consecutivo
					</Typography>
					<ProcessItem marginTop={8} title="Prefijo:" value={data.prefijo_consecutivo} />
					<Grid container style={{ gap: '0 12px', marginTop: 2 }}>
						<Grid item md={8} lg={8} xl={8}>
							<ProcessItem
								chip
								marginLeft={5}
								title="Inicial:"
								value={data.consecutivo_desde}
							/>
						</Grid>
						<Grid item md={8} lg={8} xl={8} marginTop={0.4}>
							<ProcessItem
								chip
								marginLeft={5}
								title="Final:"
								value={data.consecutivo_hasta}
							/>
						</Grid>
						<Grid item md={8} lg={8} xl={8} marginTop={0.4}>
							<ProcessItem
								chip
								chipVariant={data.cliente_genera_numeracion ? 'filled' : 'outlined'}
								marginLeft={5}
								title="Actual:"
								value={data.consecutivo_actual}
							/>
						</Grid>
					</Grid>
					<ProcessItem
						marginTop={11}
						title="Cliente genera numeración:"
						value={data.cliente_genera_numeracion ? 'Sí' : 'No'}
					/>
					<ProcessItem
						marginTop={11}
						title="Referencia detalle única:"
						value={data.flag_referencia_unica ? 'Sí' : 'No'}
					/>
				</>
				{/* Servicios y Combos asociados */}
				<>
					<div style={{ height: '165px' }}>
						<Typography
							color="#686868"
							fontFamily="Montserrat"
							fontSize={14}
							fontWeight={700}
							style={{ marginTop: 12 }}
						>
							Servicios y Combos asociados
						</Typography>
						<Grid container style={{ gap: '0 50px', marginTop: 8 }}>
							<Grid item style={{ width: 'calc(50% - 25px)' }}>
								<Typography
									color="#1A1233"
									fontFamily="Montserrat"
									fontSize={14}
									fontWeight={500}
								>
									Servicios:
								</Typography>
								<ProcessDropdown
									data={data.servicios_asociados.sort((a, b) => a - b)}
									id={`process-${data.id_proceso}-service-levels`}
									noResults="No hay servicios asociados"
									service_levels={serviceLevels}
								/>
							</Grid>
							<Grid item style={{ width: 'calc(50% - 25px)' }}>
								<Typography
									color="#1A1233"
									fontFamily="Montserrat"
									fontSize={14}
									fontWeight={500}
								>
									Combos de servicios:
								</Typography>
								<ProcessDropdown
									combos={combos}
									data={data.combos_asociados.sort((a, b) => a - b)}
									id={`process-${data.id_proceso}-combos`}
									noResults="No hay combos asociados"
								/>
							</Grid>
						</Grid>
					</div>
				</>
				{/* Liquidación y notificaciones */}
				<>
					<Typography
						color="#686868"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={700}
						style={{ marginTop: 17 }}
					>
						Liquidación y notificaciones
					</Typography>
					<ProcessItem
						marginTop={8}
						title="Liquidación en guía:"
						value={data.liquidacion_en_guia ? 'Activado' : 'Desactivado'}
					/>
					<ProcessItem
						marginTop={4}
						title="Liquidación en despacho:"
						value={data.liquidacion_en_despacho ? 'Activado' : 'Desactivado'}
					/>
					{/* <ProcessItem
					marginTop={4}
					title="Notificación a destinatario:"
					value={data.notificacion_destinatario ? 'Activado' : 'Desactivado'}
				/> */}
					<ProcessItem marginTop={4} title="Notificación push:" value={data.topic_push} />
					<ProcessItem
						marginTop={4}
						title="Cotizador:"
						value={data.cotizador ? 'Activado' : 'Desactivado'}
					/>
				</>
			</div>
			<div>
				<hr
					style={{
						borderTop: '1px solid rgb(112 103 112 / 28%)',
						marginLeft: isSmallScreen ? '-30px' : '-26px',
						marginRight: '-36px',
						marginTop: 16,
						marginBottom: 12,
					}}
				></hr>

				<IconButton
					style={{
						position: 'relative',
						float: 'right',
						marginTop: -8,
						marginRight: -20,
					}}
					onClick={() => setIsClientOpen(!isClientOpen)}
					size="small"
					sx={{ zIndex: 1, position: 'absolute', right: 12, top: 2 }}
				>
					{isClientOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
				</IconButton>
				{isClientOpen ? (
					<>
						<Typography
							color="#707070"
							fontFamily="Montserrat"
							fontSize={14}
							fontWeight={600}
						>
							Datos del cliente
						</Typography>
						<hr
							style={{
								borderTop: '1px solid rgb(112 103 112 / 28%)',
								marginLeft: isSmallScreen ? '-30px' : '-26px',
								marginRight: '-36px',
								marginTop: '12px',
							}}
						></hr>
						<div
							id="2"
							onClick={onClick}
							role="button"
							tabIndex={0}
							style={{ marginTop: 16, marginBottom: 5 }}
						>
							<Typography
								color="#1A1233"
								fontFamily="Montserrat"
								fontSize={14}
								fontWeight={700}
							>
								{data.nombre_rango}
							</Typography>

							<ProcessItem
								marginTop={8}
								title="Ciudad:"
								value={data.nombre_ciudad_rango}
							/>
							<ProcessItem
								marginTop={8}
								title="Direción:"
								value={data.direccion_rango}
							/>
							<ProcessItem
								marginTop={8}
								title="Teléfono: "
								value={data.telefono_rango}
							/>
							<ProcessItem marginTop={8} title="Correo:" value={data.correo_rango} />
						</div>
					</>
				) : (
					<Typography
						color="#707070"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={600}
						textAlign="left"
						letterSpacing={0}
					>
						Datos del cliente
					</Typography>
				)}
			</div>
		</InformationContainer>
	);
};

export default Process;
